"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeError = exports.ErrorNames = exports.ErrorCodes = void 0;
exports.ErrorCodes = {
    OK: 0,
    OTHER_ERROR: 1,
    BAD_REQUEST: 2,
    CONFIGURATION_UNSUPPORTED: 3,
    DEVICE_INELIGIBLE: 4,
    TIMEOUT: 5
};
exports.ErrorNames = {
    "0": "OK",
    "1": "OTHER_ERROR",
    "2": "BAD_REQUEST",
    "3": "CONFIGURATION_UNSUPPORTED",
    "4": "DEVICE_INELIGIBLE",
    "5": "TIMEOUT"
};
function makeError(msg, err) {
    const code = err != null ? err.errorCode : 1; // Default to OTHER_ERROR
    const type = exports.ErrorNames[('' + code)];
    const error = new Error(msg);
    error.metaData = { type, code };
    return error;
}
exports.makeError = makeError;
